// src/utils/bulkApply.js
//
// Runs an async action over a list of items one at a time, collecting the
// per-item outcome instead of aborting on the first failure. Shared by the
// multi-select bulk actions (tag / metadata / download) so each can surface a
// single "N of M succeeded" summary rather than one toast per item.

/**
 * @param {Array} items
 * @param {(item: any, index: number) => Promise<void>} fn
 * @param {(done: number, total: number) => void} [onProgress] called after each item
 * @returns {Promise<{ succeeded: any[], failed: any[] }>}
 */
export async function runBulk(items, fn, onProgress) {
    const succeeded = [];
    const failed = [];
    for (let i = 0; i < items.length; i++) {
        try {
            await fn(items[i], i);
            succeeded.push(items[i]);
        } catch (err) {
            console.error('Bulk action failed for item', items[i], err);
            failed.push(items[i]);
        }
        if (onProgress) onProgress(i + 1, items.length);
    }
    return { succeeded, failed };
}
